import { useCallback, useEffect, useState } from "react";
import type { Dripper } from "../types";
import { api } from "../lib/api";

export function useDrippers() {
  const [data, setData] = useState<Dripper[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    setError(null);
    api.drippers.list().then(setData).catch((e: Error) => setError(e.message));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh };
}
